import { TableCell } from '@mui/material';
import moneyFormat from '../functions/moneyFormat';

// pass row object as prop
const AdditionalDetailsRow = ({ row, count, tableHeader }) =>{
    return(
        <>
            {/* map display over all columns of row component */}
            {tableHeader.map( el => 
                (el['columnname'] == 'bonusamount' || el['columnname'] == 'spendcommitment') && row[el['columnname']] != null ? 
                    <TableCell align='right'>{moneyFormat(row[el['columnname']])}</TableCell>
                // standard display for other columns 
                : row[el['columnname']] == null ?
                    <TableCell>None</TableCell>
                : <TableCell>{row[el['columnname']]}</TableCell>
            )}
        </>
    );
}

export default AdditionalDetailsRow; 